import { defineComponent as _defineComponent } from 'vue'
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import { WidgetEnum } from '@/models/enums/WidgetEnum';
import WidgetContainer from '@/components/Charts/widgetContainer/WidgetContainer.vue';
import DateGroupingFilter from '@/components/DateGroupingFilter.vue';
import { dateRangeToDateStrings, yearToDate } from '@/utils/dates';
import LayoutGrid from '../dashboard/LayoutGrid.vue';
import {
  availableDashboardLayouts,
  DashboardLayout,
} from '@/models/Charts/dashboardDefinition';
import { indexedWidgetDefinitions, isNil } from '@/utils/misc';
import { computed, ref, watch } from 'vue';
import { WidgetEntry } from '@/models/Charts/compositeWidgetDefinition';
import DateRangeFilter from '@/components/DateRangeFilter.vue';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Sales',
  setup(__props) {

const gridLayout = availableDashboardLayouts[DashboardLayout.TwoByThree];

// Filters
const dateRangeSelection = ref<[Date, Date]>(yearToDate());
const selectedTimeAxisSpan = ref<FilterTimeAxisSpanEnum>(
  FilterTimeAxisSpanEnum.Month,
);

const dateRangeString = computed<[string, string]>(() =>
  dateRangeToDateStrings(dateRangeSelection.value),
);

const widgetDefinitions = ref<WidgetDefinition[]>(
  indexedWidgetDefinitions(
    [
      WidgetEnum.SalesTimeline,
      WidgetEnum.SalesCustomerGroups,
      WidgetEnum.SalesFunnel,
      WidgetEnum.SalesTopSalespeople,
      WidgetEnum.SalesFigures,
      WidgetEnum.SalesUnpaidDistribution,
    ].map(
      (widget) =>
        new WidgetDefinition(
          widget,
          [],
          dateRangeString.value,
          [],
          undefined,
          selectedTimeAxisSpan.value,
        ),
    ),
  ),
);

function updateWidgetDefinition(
  index: number,
  newWidgetDefinition: WidgetEntry,
) {
  // It's necessary because 'splice' triggers reactivity.
  // It appears that Vue is able to track the removal and insertion of the element, not just the direct change in the index.
  widgetDefinitions.value.splice(
    index,
    1,
    newWidgetDefinition as WidgetDefinition,
  );
}

function threeDotsInnerPosition(index: number | undefined): string {
  if (!isNil(index) && (index + 1) % 3 === 0) {
    return 'is-left';
  } else {
    return 'is-right';
  }
}

watch(
  () => [dateRangeString.value, selectedTimeAxisSpan.value],
  () => {
    widgetDefinitions.value = widgetDefinitions.value.map((widgetDefinition) =>
      widgetDefinition.getCopy({
        timeFilter: dateRangeString.value,
        axisSpan: selectedTimeAxisSpan.value,
      }),
    );
  },
);

return { __sfc: true,gridLayout, dateRangeSelection, selectedTimeAxisSpan, dateRangeString, widgetDefinitions, updateWidgetDefinition, threeDotsInnerPosition, WidgetContainer, DateGroupingFilter, LayoutGrid, DateRangeFilter }
}

})